module.exports = __webpack_public_path__ + "cf45c169d848d799c5f551b5207e099c.svg";